import { format as formatDate, parse } from 'date-fns';

const TIME_RE = /^\d{2}:\d{2}$/;

// 'HH:MM' 文字列を（当日基準の）Date に変換する。形式不正・不正日付は null。
// MUI TimePicker の value に渡すためのヘルパー（時刻のみ扱い、日付部分は使わない）。
export const timeStringToDate = (hhmm: string): Date | null => {
  if (!TIME_RE.test(hhmm)) return null;
  const date = parse(hhmm, 'HH:mm', new Date());
  return Number.isNaN(date.getTime()) ? null : date;
};

// Date を 0 埋めの 'HH:MM' 文字列に変換する。null・不正 Date は空文字。
export const dateToTimeString = (date: Date | null): string => {
  if (!date || Number.isNaN(date.getTime())) return '';
  return formatDate(date, 'HH:mm');
};
